import { GenericResponse } from 'services/api/base';
import {
  DecompOptions,
  DecompInformeDiario,
  DecompPremissas,
  DecompCarga,
  DecompGeracao,
  DecompResultados,
  DecompVisaoGeral,
  DecompEmpilhamento,
  DecompChuva,
} from 'types/Relatorios/Decomp';

export const transformDecompOptionsResponse = (
  response: GenericResponse<DecompOptions>,
): DecompOptions => response.data;

export const transformDecompInformeDiarioResponse = (
  response: GenericResponse<DecompInformeDiario>,
): DecompInformeDiario => response.data;

export const transformDecompPremissasResponse = (
  response: GenericResponse<DecompPremissas>,
): DecompPremissas => response.data;

export const transformDecompCargaResponse = (
  response: GenericResponse<DecompCarga>,
): DecompCarga => response.data;

export const transformDecompGeracaoResponse = (
  response: GenericResponse<DecompGeracao>,
): DecompGeracao => response.data;

export const transformDecompResultadosResponse = (
  response: GenericResponse<DecompResultados>,
): DecompResultados => response.data;

export const transformDecompVisaoGeralResponse = (
  response: GenericResponse<DecompVisaoGeral>,
): DecompVisaoGeral => response.data;

export const transformDecompEmpilhamentoResponse = (
  response: GenericResponse<DecompEmpilhamento>,
): DecompEmpilhamento => response.data;

export const transformDecompChuvaResponse = (
  response: GenericResponse<DecompChuva>,
): DecompChuva => response.data;
